import React from "react";
import { Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  formBlock: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 20,
    "& label.Mui-focused": {
      borderRadius: 20,
      color: theme.palette.secondary.main,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderRadius: 20,
        borderColor: theme.palette.secondary.main,
      },
    },
  },
}));

const FormBlockComponent = ({ handleChange, label, value, minRows, disabled, required }) => {
  const classes = useStyles();
  const intl = useIntl();

  const caption = intl.formatMessage({ id: label });

  return (
    <div className={classes.formBlock}>
      <Typography variant={"caption"}>{required ? `${caption}*` : caption}</Typography>
      <TextField
        id="outlined-basic"
        variant="outlined"
        onChange={handleChange}
        value={value}
        className={classes.textField}
        minRows={minRows}
        disabled={disabled}
      />
    </div>
  );
};

FormBlockComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  minRows: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

FormBlockComponent.defaultProps = {
  minRows: 1,
  disabled: false,
  required: false,
};

export default FormBlockComponent;
